import React, { useEffect, useState, useRef } from 'react';
import {
    Container,
    Dropdown,
    Image,
    InputGroup,
    Nav,
    Navbar,
    Stack,
    Form,
    Button,
} from 'react-bootstrap';
import Logo from '../../Assets/Img/white_logo.png';
import { Link, Outlet, useLocation, useNavigate } from 'react-router';
import './dashboardLayout.css';
import Avtar from '../../Assets/Img/avatar.png';
import dashIcon from '../../Assets/Img/dash.png';
import testCardImg from '../../Assets/Img/eyeTestIcon.png';
import heartHand from '../../Assets/Img/hand-heart.png';
import download from '../../Assets/Img/downlod_icon.png';
import emailIcon from '../../Assets/Img/email.png';
import Back from '../../Assets/Img/back.png';
import whatsNewIcon from '../../Assets/Img/new.png';
import NetherlandFlag from '../../Assets/Img/Netherlands.png';
import EnglandFlag from '../../Assets/Img/England.png';
import FranceFlag from '../../Assets/Img/France.png';
import { CircleUserRound, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import AddPatient from '../Patient/addPatient';
import config from '../../Api/config';
import { getSecureItem, removeSecureItem } from "../../utils/secureStorage";
const DashboardLayout = () => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    const user = getSecureItem('UserData');
    const scrollContainerRef = useRef(null);
    useEffect(() => {
        const forceLogout = () => {
            removeSecureItem("authToken");
            removeSecureItem("UserData");
            removeSecureItem("UserType");
            removeSecureItem("ExternalOptician");

            localStorage.removeItem("patientEmail");
            localStorage.removeItem("posListConfigCopy");
            localStorage.removeItem("opticianListConfigCopy");
            localStorage.removeItem("orderListConfigCopy");

            navigate("/login", { replace: true });
        };

        // 🔍 Initial validation on page load
        const token = getSecureItem("authToken");
        const user = getSecureItem("UserData");

        if (!token || !user) {
            forceLogout();
            return;
        }

        // 👀 Live detection: DevTools / another tab modification
        const handleStorageChange = () => {
            const liveToken = getSecureItem("authToken");
            const liveUser = getSecureItem("UserData");

            if (!liveToken || !liveUser) {
                forceLogout();
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, [navigate]);

    useEffect(() => {
        console.log(
            'profile image url ---- ',
            `${config.img_URL}/${user?.profileImagePath}`
        );
    });
    const [lang, setLang] = useState('fr');
    const [show, setShow] = useState(false);
    const location = useLocation();

    console.log('location from navbar ====>>> ', location);

    const pathnames = location.pathname.split('/').filter((x) => x);
    const breadcrumbs = pathnames
        .map((word, index) =>
            index === 0
                ? word.replace(/-([a-z])/g, (_, char) => char).toLowerCase()
                : word
                    .replace(/-([a-z])/g, (_, char) => char)
                    .charAt(0)
                    .toUpperCase() +
                word
                    .replace(/-([a-z])/g, (_, char) => char)
                    .slice(1)
                    .toLowerCase()
        )
        .join('');

    const Menu = {
        OPTICIAN: [
            {
                title: 'dashboard',
                link: '/dashboard',
                icon: dashIcon,
            },
            {
                title: 'patientListMenu',
                link: '/patient/list',
                icon: heartHand,
            },
            {
                title: 'eyeTestListMenu',
                link: '/eyetest/list',
                icon: testCardImg,
            },
            ...(user?.userType == 'OPTICIAN' && !user?.isExternal
                ? [
                    {
                        title: 'vosCommandes',
                        link: '/order/list',
                        icon: dashIcon,
                    },
                    {
                        title: 'Télécharger des images',
                        link: '/bulk-upload',
                        icon: dashIcon,
                    },
                ]
                : []),
            {
                title: 'emailChangeRequest',
                link: '/email/list',
                icon: emailIcon,
            },
        ],
        BACKOFFICE: [
            {
                title: 'dashboard',
                link: '/dashboard',
                icon: dashIcon,
            },
            {
                title: 'patientListMenu',
                link: '/patient/list',
                icon: heartHand,
            },
            {
                title: 'eyeTestListMenu',
                link: '/eyetest/list',
                icon: testCardImg,
            },
            {
                title: 'vosCommandes',
                link: '/order/list',
                icon: testCardImg,
            },
            {
                title: 'emailChangeRequest',
                link: '/email/list',
                icon: emailIcon,
            },
        ],
        ADMIN: [
            {
                title: 'dashboard',
                link: '/dashboard',
                icon: dashIcon,
            },
            {
                title: 'Opticiens',
                link: '/optician/list',
                icon: heartHand,
            },
            {
                title: 'Points de vente',
                link: '/pos/list',
                icon: heartHand,
            },
            {
                title: 'Docteurs',
                link: '/doctor/list',
                icon: heartHand,
            },
            {
                title: 'Back Office',
                link: '/backoffice/list',
                icon: heartHand,
            },
            {
                title: 'patientListMenu',
                link: '/patient/list',
                icon: heartHand,
            },
            {
                title: 'eyeTestListMenu',
                link: '/eyetest/list',
                icon: testCardImg,
            },
            {
                title: 'vosCommandes',
                link: '/order/list',
                icon: testCardImg,
            },
            {
                title: 'emailChangeRequest',
                link: '/email/list',
                icon: emailIcon,
            },
            {
                title: 'Télécharger des images',
                link: '/bulk-upload',
                icon: dashIcon,
            },
        ],
        PATIENT: [
            {
                title: 'dashboard',
                link: '/dashboard',
                icon: dashIcon,
            },
            {
                title: 'eyeTestListMenu',
                link: '/eyetest/list',
                icon: testCardImg,
            },
        ],
        EYEDOCTOR: [
            {
                title: 'dashboard',
                link: '/dashboard',
                icon: dashIcon,
            },
            {
                title: 'eyeTestListMenu',
                link: '/eyetest/list',
                icon: testCardImg,
            },
            {
                title: 'pendingValidation',
                link: '/eyetest/list',
                icon: testCardImg,
                state: { status: 'pendingValidation' }, // Add state for filtering
            },
        ],
    };

    useEffect(() => {
        i18n.changeLanguage('fr');
        const token = getSecureItem('authToken');

        if (!token) {
            navigate('/login');
        }
    }, []);

    const changeLanguage = (lng) => {
        setLang(lng);
        i18n.changeLanguage(lng);
    };

    const handleMenuClick = (item) => {
        localStorage.removeItem("opticianListConfigCopy");
        localStorage.removeItem("posListConfigCopy");
        localStorage.removeItem("patientListConfigCopy");
        localStorage.removeItem("orderListConfigCopy");
        localStorage.removeItem("eyeTestListConfigCopy");
        navigate(item.link, { state: item.state || {} });
    };

    return (
        <>
            <div className="layout_wrapper">
                <Navbar className="nav_wrapper">
                    <Container fluid className="nav_wrapper_inner">
                        <Navbar.Brand onClick={() => {
                            // ✅ Clear same configs like menu
                            localStorage.removeItem("opticianListConfigCopy");
                            localStorage.removeItem("posListConfigCopy");
                            localStorage.removeItem("patientListConfigCopy");
                            localStorage.removeItem("orderListConfigCopy");
                            localStorage.removeItem("eyeTestListConfigCopy");

                            // ✅ Force state change to trigger refresh
                            navigate('/dashboard', {
                                state: { refresh: Date.now() }
                            });
                        }}>
                            {' '}
                            <Image src={Logo} width={95} />
                        </Navbar.Brand>
                        {user?.userType == 'OPTICIAN' && (
                            <div
                                className="w-100"
                                style={{ padding: '16px 16px 8px' }}
                            >
                                <Button
                                    className="nav_addNew_Button"
                                    onClick={() => setShow(true)}
                                >
                                    <Plus width={16} height={16} />
                                    <span>{t('addPatient')}</span>
                                </Button>
                                <AddPatient
                                    show={show}
                                    setShow={setShow}
                                    editData={{}}
                                />
                            </div>
                        )}

                        <Nav className="nav_menus">
                            {Menu &&
                                Menu[user?.userType]?.map((item, index) => {
                                    if (item.title) {
                                        return (
                                            <div
                                                key={index}
                                                onClick={() =>
                                                    handleMenuClick(item)
                                                }
                                                className="nav-link"
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <img src={item.icon} />
                                                <span>
                                                    {t(`${item.title}`)}
                                                </span>
                                            </div>
                                        );
                                    }
                                })}
                        </Nav>
                    </Container>
                </Navbar>
                <div className="layout_wrapper_right">
                    <div className="layout_wrapper_right_nav">
                        <Stack direction="horizontal" gap={3}>
                            <div className="breadcrumbs">
                                <h4>
                                    {' '}
                                    {breadcrumbs !== 'dashboard' ? (
                                        <Button
                                            variant="light"
                                            style={{
                                                width: 24,
                                                height: 24,
                                                padding: 0,
                                                marginRight: 5,
                                            }}
                                            // onClick={() => navigate(-1)}
                                            onClick={() => {
                                                let path = location.pathname;
                                                navigate(-1);

                                                // if (path === '/eyetest/view') {
                                                //     navigate('/eyetest/list', {
                                                //         replace: true,
                                                //         state: {
                                                //             pageCount:
                                                //                 location.state
                                                //                     .pageCount,
                                                //         },
                                                //     });
                                                // } else {
                                                //     navigate(-1);
                                                // }
                                            }}
                                        >
                                            <Image src={Back} width={16} />
                                        </Button>
                                    ) : (
                                        ''
                                    )}
                                    {location.search
                                        ? decodeURIComponent(
                                            location.search
                                        ).replace('?', '')
                                        : breadcrumbs === 'opticianView'
                                            ? t('Perfil opticien')
                                            : t(`${breadcrumbs}`)}
                                </h4>
                            </div>
                            <div className="header_language ms-auto">
                                <Dropdown>
                                    <Dropdown.Toggle
                                        id="dropdown-basic"
                                        variant="link"
                                    >
                                        <Image
                                            src={`${lang == 'en'
                                                ? EnglandFlag
                                                : lang == 'fr'
                                                    ? FranceFlag
                                                    : NetherlandFlag
                                                }`}
                                            width={24}
                                            rounded
                                        />
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                            onClick={() => changeLanguage('fr')}
                                        >
                                            <Image
                                                src={FranceFlag}
                                                width={24}
                                                rounded
                                            />{' '}
                                            {t('french')}
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            onClick={() => changeLanguage('en')}
                                        >
                                            <Image
                                                src={EnglandFlag}
                                                width={24}
                                                rounded
                                            />{' '}
                                            {t('english')}
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                            <div className="avtar_wrapper">
                                <Dropdown>
                                    <Dropdown.Toggle
                                        id="dropdown-basic"
                                        variant="link"
                                    >
                                        {user?.profileImagePath !== '' ? (
                                            <Image
                                                src={`${config.img_URL}/${user?.profileImagePath}`}
                                                style={{
                                                    width: '40px',
                                                    height: '40px',
                                                }}
                                                roundedCircle
                                            />
                                        ) : (
                                            <CircleUserRound
                                                width={40}
                                                height={40}
                                                stroke="#000"
                                            />
                                        )}
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item
                                            onClick={() =>
                                                navigate('/profile', {
                                                    state: {
                                                        userData: user,
                                                        editable: true,
                                                    },
                                                })
                                            }
                                        >
                                            {t('profile')}
                                        </Dropdown.Item>
                                        <Dropdown.Item
                                            onClick={() => {
                                                localStorage.clear();
                                                navigate('/login');
                                            }}
                                        >
                                            {t('logout')}
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </Stack>
                    </div>
                    <Container
                        className="content_wrapper"
                        fluid
                        ref={scrollContainerRef}
                    >
                        <Outlet context={{ scrollContainerRef }} />
                    </Container>
                </div>
            </div>
        </>
    );
};
export default DashboardLayout;
